<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="19" height="23" viewBox="0 0 19 23.688">
      <g transform="translate(0.418 -55.014)">
        <path id="Path_5198" :fill="color" data-name="Path 5198" d="M9.5,0A9.508,9.508,0,0,0,0,9.5a9.346,9.346,0,0,0,.169,1.783c0,.035.025.139.065.318a9.351,9.351,0,0,0,.636,1.872c1.023,2.409,3.273,6.108,8.209,10.071a.672.672,0,0,0,.844,0c4.931-3.963,7.186-7.663,8.209-10.071a9.246,9.246,0,0,0,.636-1.872c.04-.179.06-.283.065-.318A9.765,9.765,0,0,0,19,9.5,9.522,9.522,0,0,0,9.5,0ZM17.5,11.044c0,.01,0,.02,0,.03s-.02.1-.045.214v.01a7.884,7.884,0,0,1-.551,1.619s0,.015-.01.02c-.929,2.2-2.965,5.557-7.394,9.217-4.43-3.66-6.466-7.017-7.394-9.217,0,0,0-.015-.01-.02A8.41,8.41,0,0,1,1.539,11.3v-.01c-.03-.114-.04-.189-.045-.214s0-.02,0-.035A8.154,8.154,0,1,1,17.649,9.49,8.085,8.085,0,0,1,17.5,11.044Z" transform="translate(-0.418 55.014)" />
        <path id="Path_5199" :fill="color" data-name="Path 5199" d="M75.829,71.9a6.029,6.029,0,1,0,6.029,6.029A6.038,6.038,0,0,0,75.829,71.9Zm0,10.717a4.688,4.688,0,1,1,4.688-4.688A4.693,4.693,0,0,1,75.829,82.617Z" transform="translate(-66.752 -13.316)" />
      </g>
    </svg>
</template>

<script>
export default {
  name: 'AppMarker',
  props: ['color'],
  data () {
    return {

    }
  },
  computed: {

  },
  methods: {

  }
}
</script>
